import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useTranslation } from '../../i18n';

export function AlertsList({ alerts }) {
  const { t } = useTranslation();
  if (alerts.length === 0) return null;
  return (
    <div className="space-y-2" data-testid="alerts-section">
      <p className="overline">{t('alerts')}</p>
      {alerts.map(alert => (
        <div key={alert.id || `alert-${alert.type}-${alert.message}`} className="flex items-center gap-3 bg-warn/5 border border-warn/30 rounded-md px-4 py-3">
          <AlertTriangle className="w-4 h-4 text-warn flex-shrink-0" />
          <p className="text-sm text-slate-200">{alert.message}</p>
        </div>
      ))}
    </div>
  );
}
